(() => {
  const init = () => {
    const root = document.querySelector('[data-mavella-release]');
    if (!root || root.dataset.ready) return;
    root.dataset.ready = 'true';
    root.addEventListener('click', (event) => {
      const open = event.target.closest('[data-mv-open]');
      if (open) {
        const dialog = document.getElementById(open.dataset.mvOpen);
        if (dialog) dialog.showModal();
      }
      const close = event.target.closest('[data-mv-close]');
      if (close) close.closest('dialog').close();
      const notify = event.target.closest('[data-mv-notify]');
      if (notify) {
        notify.closest('dialog').close();
        requestAnimationFrame(() => document.getElementById('MavellaReleaseEmail').focus({preventScroll:false}));
      }
      if (event.target.tagName === 'DIALOG') {
        const rect = event.target.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
      }
    });
  };
  init();
  document.addEventListener('shopify:section:load', init);
})();
